import styled from 'styled-components';

export const Wrapper = styled.div<{ $numColumns: number }>`
	display: grid;
	grid-column-gap: 8px;
	grid-template-columns: ${p => (p.$numColumns === 2 ? '1fr 1fr' : '1fr')};
	width: 100%;
`;
